import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgClass } from '@angular/common';
import * as Materialize from 'angular2-materialize';
import { CognitoCallback, Callback, ForgotPasswordCallback } from '../cognito/cognito.service';
import { UserLoginService } from '../cognito/user-login.service';
import { NavbarService } from '../navbar/navbar.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: 'changepassword.component.html',
  styleUrls: ['changepassword.component.css'],
  providers: [UserLoginService]
})
export class ChangepasswordComponent implements OnInit, OnDestroy, CognitoCallback, ForgotPasswordCallback {

  email: string = '';
  changepasswordmessage: string = '';
  changepasswordcode: string = '';
  changepasswordpassword: string = '';
  changepasswordconfirm: string = '';

  constructor(private router: Router,
              private route: ActivatedRoute,
              private userLoginService: UserLoginService,
              public navService: NavbarService) {}

  ngOnInit() {
    this.navService.hide();
    this.email = localStorage.getItem('changepasswordemail');
    console.log('email:', this.email);
  }

  ngOnDestroy() {
  }

  onChangePassword() {
    console.log('onChangePassword() clicked');

    if (this.changepasswordcode == null || this.changepasswordpassword == null || this.changepasswordconfirm == null) {
      this.changepasswordmessage = 'All fields are required';
      return;
    }

    if (this.changepasswordpassword !== this.changepasswordconfirm) {
      console.error('Passwords do not match');
      this.changepasswordmessage = 'All fields are required';
      return;
    }

    this.changepasswordmessage = null;
    this.userLoginService.confirmNewPassword(this.email, this.changepasswordcode, this.changepasswordpassword, this);
  }

  cognitoCallback(message: string, result: any) {
    console.log('Changing password...');
    if (message != null) { //error
      this.changepasswordmessage = message;
      console.error('ERROR: ' + this.changepasswordmessage);
    } else { //success
      Materialize.toast('Password changed', 5000);
      this.router.navigate(['/login']);
    }
  }

  onLogin() {
    this.router.navigate(['/login']);
  }

  onResendCode() {
    this.userLoginService.forgotPassword(this.email, this);
  }

  messageSent(message: string) {
    console.log('cognitoCallback called');
    if (message != null) { //error
      this.changepasswordmessage = message;
      console.error('ERROR: ' + this.changepasswordmessage);
    } else { //success
      Materialize.toast('Verification code email resent.', 5000);
    }
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/changepassword/changepassword.component.ts